import gql from "graphql-tag";

export const FILL_ENCUESTA = gql`
  mutation fillEncuesta(
    $id_encuesta: Int!
    $respuestas: [Float!]
    $observaciones: String
  ) {
    fillEncuesta(
      id_encuesta: $id_encuesta
      respuestas: $respuestas
      observaciones: $observaciones
    ) {
      id
      estado_encuesta {
        nombre
      }
      tipo_encuesta {
        id
        tipo
      }
      resultado
      resultado_numerico
      color
    }
  }
`;

export const REVISAR_ENCUESTA = gql`
  mutation revisarEncuesta($id_encuesta: Int!) {
    revisarEncuesta(id_encuesta: $id_encuesta) {
      id
    }
  }
`;
